import {Component, HostBinding, HostListener, OnDestroy, OnInit} from '@angular/core';
import * as fromStore from '../store';
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {UserService} from '../user/user.service';
import {ProductService} from "../websites/website/product.service";
import {Website} from "../websites/website/website";
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../user/user-subscription";
import {combineLatest, Subscription} from 'rxjs';
import {filter, first, map, switchMap} from "rxjs/operators";
import {User} from "../user/user";
import {PaymentDialogComponent} from "../workspace/billing/payment-dialog/payment-dialog.component";
import {DialogService} from "../../ng2-bootstrap-modal/dialog.service";
import {DbDatePipe} from "../shared/pipes/db-date.pipe";

@Component({
    selector: 'db-user-summaries',
    templateUrl: './user-summaries.component.html',
    styleUrls: ['./user-summaries.component.scss'],
    standalone: false
})
export class UserSummariesComponent implements OnInit, OnDestroy {

  public UserSubscriptionType = UserSubscriptionType;
  public UserSubscriptionCategory = UserSubscriptionCategory;

  public loading: boolean = true;
  public websites$: Observable<Website[]>;
  public filteredWebsites$: Observable<Website[]>;
  public hostedWebsites: Website[];
  public hasHostingBanner: any;

  public toggled$: Observable<boolean>;
  private _toggled: boolean;
  private _toggledSubscription: Subscription;
  public currentSubscription: UserSubscription;
  public user: User;
  public usedHostingVisits: number;
  public usedHostingVisitsReal: number;
  public totalHostingVisits: number;
  public availableVisits: number;
  public availableStorage: number;
  public usedHostingStorage: number;
  public usedHostingStorageReal: number;
  public totalHostingStorage: number;
  public totalWebsitesCount: number;
  generatedWebsitesInfo: any;
  public hostingsLimit: number;
  public usedHostingVisitsStartDate: any;
  public usedHostingVisitsEndDate: any;
  public totalHostingStorageUnit: string;
  public website: Website;
  private _subscriptions: Subscription[];
  public hasUpgrade: boolean;
  private hasHostedWebsites: boolean = false;


  /************ backup charts *****************/

  public doughnutChartOptions: any = {
    cutoutPercentage: 65,
    legend: {
      text: false
    },
    tooltips: {
      enabled: false
    },
    animation: {
      duration: 1000
    }
  };

  public doughnutChartImageOptOptions: any = {
    cutoutPercentage: 65,
    legend: {
      text: false
    },
    tooltips: {
      enabled: false
    },
    animation: {
      duration: 2000
    },
    circumference: Math.PI
  };


  public doughnutChartSimulateOptions: any = {
    cutoutPercentage: 65,
    legend: {
      text: false
    },
    tooltips: {
      enabled: false
    },
    animation: {
      enabled: false,
      duration: 0
    }
  };

  public doughnutChartHostingBlockOptions: any = {
    cutoutPercentage: 73,
    legend: {
      text: false
    },
    tooltips: {
      enabled: false
    },
    animation: {
      enabled: false,
      duration: 0
    }
  };

  public doughnutChartHostingBlockSimulateOptions: any = {
    cutoutPercentage: 73,
    legend: {
      text: false
    },
    tooltips: {
      enabled: false
    },
    animation: {
      enabled: false,
      duration: 0
    }
  };

  public doughnutChartHostingVisitsOptions: any = {
    cutoutPercentage: 57,
    legend: {
      text: false
    },
    tooltips: {
      enabled: false
    },
    animation: {
      enabled: false,
      duration: 0
    }
  };

  public doughnutChartHostingVisitsSimulateOptions: any = {
    cutoutPercentage: 57,
    legend: {
      text: false
    },
    tooltips: {
      enabled: false
    },
    animation: {
      enabled: false,
      duration: 0
    }
  };

  public doughnutHostingResourseChartColours: any[] = [{
    backgroundColor: ["#5cc971", "#f4f4f4"],
    hoverBackgroundColor: ["#5cc971", "#f4f4f4"],
    borderWidth: [0, 0],
    hoverBorderWidth: [0, 0],
    pointBorderWidth: [5, 5],
  }];

  public doughnutHostingStorageChartColours: any[] = [{
    backgroundColor: ["#3339F1", "#f4f4f4"],
    hoverBackgroundColor: ["#3339F1", "#f4f4f4"],
    borderWidth: [0, 0],
    hoverBorderWidth: [0, 0],
    pointBorderWidth: [5, 5],
  }];

  public doughnutAiGenChartColours: any[] = [{
    backgroundColor: ["#2A2F30", "#f4f4f4"],
    hoverBackgroundColor: ["#2A2F30", "#f4f4f4"],
    borderWidth: [0, 0],
    hoverBorderWidth: [0, 0],
    pointBorderWidth: [5, 5],
  }];

  public doughnutBackupChartColours: any[] = [{
    backgroundColor: ["#2160b5", "#f4f4f4"],
    hoverBackgroundColor: ["#2160b5", "#f4f4f4"],
    borderWidth: [0, 0],
    hoverBorderWidth: [0, 0],
    pointBorderWidth: [5, 5],
  }];

  public doughnutSimulateChartColours: any[] = [{
    backgroundColor: ["#f4f4f4", "#f4f4f4"],
    hoverBackgroundColor: ["#f4f4f4", "#f4f4f4"],
    borderWidth: [0, 0],
    hoverBorderWidth: [0, 0],
    pointBorderWidth: [5, 5],
  }];


  public doughnutIoChartColours: any[] = [{
    backgroundColor: ["#29b311", "#f4f4f4"],
    hoverBackgroundColor: ["#29b311", "#f4f4f4"],
    borderWidth: [0, 0],
    hoverBorderWidth: [0, 0],
    pointBorderWidth: [5, 5],
  }];


  /************ backup charts *****************/

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _userService: UserService,
    private _productService: ProductService,
    private _dbDatePipe: DbDatePipe,
    private _dialogService: DialogService,
  ) {

  }

  @HostBinding('class.db-user-summaries__host_toggled') get hostToggled(): boolean {
    return this._toggled;
  }

  @HostListener('click') onMouseOver() {
    this.toggle();
  }
  ngOnInit(): void {
    this.toggled$ = this._store.select(fromStore.getUserSummariesToggled);
    this._toggledSubscription = this.toggled$.subscribe((toggled: boolean): void => {
      this._toggled = toggled;
      this._store.dispatch(new fromStore.LoadGeneratedWebsiteCount);
    });

    this.addSubscriptions();
  }

  public addSubscriptions(): void {
    this._subscriptions = [];

    this.websites$ = <any>this._store.select(fromStore.getWebsites);
    this.filteredWebsites$ = this.websites$
      .pipe(
        map((websites: Website[]): any => websites.filter((website: Website) => website.type === 'live' && !!website.domain_hash && !website.parentId))
      );

    this.filteredWebsites$.subscribe((websites): void => {
      websites.forEach((website: Website): void => {
        if (website && website.type === 'live' && !!website.domain_hash && !website.parentId) {
          this.hasHostedWebsites = true;
        }
      });
    });

    this._subscriptions.push(
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription),
            this._store.select(fromStore.getGeneratedWebsitesCount)
          ))
        )
        .subscribe((data: any) => {
          this.user = data[0];
          if (this.user) {
            this.hasHostingBanner = localStorage.getItem("showConnectBanner" + this.user.id);
          }
          this.currentSubscription = data[1];
          this.totalHostingVisits = this.user?.hosting_services && this.currentSubscription?.plan ? this.user?.additionalWebsiteCount ? (parseInt(this.user?.hosting_services?.hosting_visits?.parameter_value, 10) + (this.currentSubscription?.plan?.additionalDomainCount * parseInt(this.user?.hosting_services?.hosting_additional_visits ? this.user?.hosting_services?.hosting_additional_visits?.parameter_value : 0, 10))) : (this.currentSubscription?.plan?.additionalDomainCount ? this.currentSubscription?.plan?.additionalDomainCount * parseInt(this.user?.hosting_services?.hosting_visits?.parameter_value, 10) : parseInt(this.user?.hosting_services?.hosting_visits?.parameter_value, 10)) : null;
          this.totalHostingStorage = this.user?.hosting_services && this.currentSubscription?.plan ? this.user?.additionalWebsiteCount ? (parseInt(this.user?.hosting_services?.hosting_storage?.parameter_value, 10) + (this.currentSubscription?.plan?.additionalDomainCount * parseInt(this.user?.hosting_services?.hosting_additional_storage?.parameter_value, 10))) : (this.currentSubscription?.plan?.additionalDomainCount ? this.currentSubscription?.plan?.additionalDomainCount * parseInt(this.user?.hosting_services?.hosting_storage?.parameter_value, 10) : parseInt(this.user?.hosting_services?.hosting_storage?.parameter_value, 10) ) : null;
          this.totalHostingStorageUnit = this.user && this.user.hosting_services ? this.user.hosting_services.hosting_storage.unit : null;
          // this.hostingsLimit = this.user && this.user.hosting_services && this.currentSubscription && this.currentSubscription.plan ? parseInt(this.user.hosting_services.domain_count.parameter_value, 10) + this.user.additionalWebsiteCount + this.currentSubscription.plan.additionalDomainCount : null;
          this.hostingsLimit = this.user && this.user.hosting_services && this.currentSubscription && this.currentSubscription.plan ? parseInt(this.user.hosting_services.domain_count.parameter_value, 10) + this.user.additionalWebsiteCount : null;
          if ((data[2] || data[2] === 0) && this.currentSubscription?.plan?.services?.ai_builder) {
            const regenerationWebsitesCount: number = parseInt(this.currentSubscription.plan.services.ai_builder.regeneration_count.parameter_value, 10);
            const regenerationAdditionalWebsitesCount: number = parseInt(
                this.currentSubscription.plan.additionalDomainCount &&
                this.currentSubscription.plan.services.ai_builder.regeneration_additional_count ?
                  this.currentSubscription.plan.services.ai_builder.regeneration_additional_count.parameter_value : 0, 10)
              * this.currentSubscription.plan.additionalDomainCount;
            this.totalWebsitesCount = regenerationWebsitesCount + regenerationAdditionalWebsitesCount;
          }

        })
    );

    this._subscriptions.push(
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => this._store.select(fromStore.getUserUpgradableSubscription())),
          first()
        )
        .subscribe((userUpgradableSubscription: UserSubscription) => {
          this.hasUpgrade = !!userUpgradableSubscription;
        })
    );

    this._subscriptions.push(
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getHostingResources),
            this._store.select(fromStore.getHostingVisits),
            this._store.select(fromStore.getGeneratedWebsitesCount),
          ))
        )
        .subscribe((data: any) => {
          if (data && data[0] && data[1] && (data[2] || data[2] === 0)) {
            this.loading = false;
          }
          const hostingResources = data[0];
          if (hostingResources && this.hasHostedWebsites) {
            this.usedHostingStorageReal = hostingResources.storage;
            this.usedHostingStorage = this.totalHostingStorage / this.usedHostingStorageReal < 50 ? this.usedHostingStorageReal : this.usedHostingStorageReal * 50;
            this.availableStorage = this.totalHostingStorage * 1024 * 1024 > this.usedHostingStorageReal ? (this.totalHostingStorage * 1024 * 1024 - this.usedHostingStorageReal) : 0;
            if (this.currentSubscription?.isDedicatedVM ? this.usedHostingStorageReal >= this.totalHostingStorage * 1024 * 1024 * 0.95 : this.usedHostingStorageReal >= this.totalHostingStorage * 1024 * 1024) {
              this.doughnutHostingStorageChartColours[0]['backgroundColor'] = ["#D41125", "#f4f4f4"];
              this.doughnutHostingStorageChartColours[0]['hoverBackgroundColor'] = ["#D41125", "#f4f4f4"];
            }
          }

          const hostingVisits = data[1];
          if (hostingVisits && this.hasHostedWebsites) {
            this.usedHostingVisitsReal = hostingVisits.visitors;
            this.usedHostingVisitsStartDate = this._dbDatePipe.transform(new Date(hostingVisits.start_date), 'MMM dd');
            this.usedHostingVisitsEndDate = this._dbDatePipe.transform(new Date(hostingVisits.end_date), 'MMM dd');
            this.usedHostingVisits = this.usedHostingVisitsReal > 20 ? this.usedHostingVisitsReal : 20;
            this.availableVisits = this.totalHostingVisits > this.usedHostingVisitsReal ? (this.totalHostingVisits - this.usedHostingVisitsReal) : 0;
            if (this.currentSubscription?.isDedicatedVM ? this.usedHostingVisits >= this.totalHostingVisits * 0.95 : this.usedHostingVisits >= this.totalHostingVisits) {
              this.doughnutHostingResourseChartColours[0]['backgroundColor'] = ["#D41125", "#f4f4f4"];
              this.doughnutHostingResourseChartColours[0]['hoverBackgroundColor'] = ["#D41125", "#f4f4f4"];
            }
          }

          const aiGenWebsites = data[2];
          if (aiGenWebsites || aiGenWebsites === 0) {
            this.generatedWebsitesInfo = {
              real: aiGenWebsites,
              available: this.totalWebsitesCount - aiGenWebsites
            };
            if (aiGenWebsites >= this.totalWebsitesCount) {
              this.doughnutAiGenChartColours[0]['backgroundColor'] = ["#D41125", "#f4f4f4"];
              this.doughnutAiGenChartColours[0]['hoverBackgroundColor'] = ["#D41125", "#f4f4f4"];
            }
          }

        })
    );
  }

  private _countOptimalStatValue(total: number, used: number): number {
    const usedPercent: number = (used / total * 100);
    return usedPercent < 5 && usedPercent !== 0 ? (5 * total) / 100 : used;
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this._subscriptions = null;
    this._toggledSubscription.unsubscribe();
  }

  public toggle(): void {
    this._store.dispatch(new fromStore.ToggleUserSummaries());
  }

  public stopEvent($event: any): void {
    $event.stopPropagation();
  }
  public renewUserSubscription(): void {

    this._dialogService
      .addDialog(PaymentDialogComponent, {
        upgradeSubscription: this.currentSubscription,
        fromDialog: false,
        renew: true
      })
      .subscribe((reopenLast: boolean): void => {
        if (reopenLast) {
          //  this.loadData(true);
        }
      });
    this._store.dispatch(new fromStore.ToggleUserSummaries());
  }
}
